import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentOzonPay = (): boolean => useExperimentFlag('enable_ozon_pay');
